import { useLocation } from 'react-router-dom';
import { InfoChip, Link } from '@components';
import { TItemType } from '@types';
import { formatItemTypeDefinition } from '@utils';

export interface ItemTypeBannerProps {
	itemType: TItemType;
	/** Off the settings page: opens the Item type's row there in a new tab, so edits here survive. */
	inNewTab?: boolean;
}

/** What one unit of an Item type is, with a link to its row in the Item types table to edit it. */
export const ItemTypeBanner = (props: ItemTypeBannerProps) => {
	const { itemType, inNewTab = false } = props;
	// The query says whose settings these are, so the link keeps it.
	const { search } = useLocation();
	// A Shipper's own page has none, and its settings need none.
	const sid = new URLSearchParams(search).get('sid');

	return (
		<InfoChip text={formatItemTypeDefinition(itemType)} stretch>
			{
				inNewTab ?
					<Link to={`/shipper/ratecards/settings${sid ? `?sid=${sid}` : ''}#${itemType.id}`} target={'_blank'}>
						Edit in Item types ↗
					</Link> :
					<Link to={`${search}#${itemType.id}`}>Edit in Item types</Link>
			}
		</InfoChip>
	);
}
